import React, { ChangeEvent, useState } from 'react'

import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close';

import './Search.scss'
import { useNavigate } from 'react-router-dom';

const Search = (props: {staticSearch?: boolean}) => {

    const [search, setSearch] = useState('')
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    const redirect = () => {
        navigate(`/search?${search}`)
        if(!props.staticSearch) setOpen(false)
        setSearch('')
    }
    return (
        <div className='search'>
            <div className={
                `search-input ${!!props.staticSearch ? 'paddingless' : ''} ${open || !!props.staticSearch ? 'active' : ''}`}>
                <input type="text" placeholder='Search...' id='searchField' value={search} onChange={(e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}/>
                <SearchIcon onClick={() => open ? redirect() : setOpen(true)}/>
            </div>
            {!!props.staticSearch ? <></> : 
            <div className={`search-close ${open || !!props.staticSearch ? 'active' : ''}`} onClick={() => setOpen(false)}>
                <CloseIcon sx={{width: 20, height: 20}}/>
            </div>}
        </div>
    )
}

export default Search